<template>
  <div :class="{ 'mt-30-px': !showNavbar }">
    <notifications></notifications>
    <navbar v-if="showNavbar" :docsName="docsName" />

    <ValidationObserver v-slot="{ invalid }">
      <div class="container-fluid row">
        <div v-if="showNavbar" class="col-xl-12">
          <div class="row">
            <div class="col-xl-12 block br-t-l-0 mb-3">
              <head-menu
                :col="12"
                class="d-xl-flex"
                :headline="navbarTitel"
              ></head-menu>
              <div class="row mt-2 d-flex justify-content-between">
                <div class="ml-4">
                  <button
                    v-if="editable"
                    v-shortkey.once="['ctrl', 's']"
                    class="btn btn-success mr-2"
                    :disabled="invalid"
                    @click="speichern"
                    @shortkey="speichern"
                  >
                    {{ $t("global.save") }}
                  </button>

                  <button class="btn btn-primary mr-2" @click="abbrechen">
                    <font-awesome-icon icon="fa-solid fa-list" class="mr-2" />{{
                      $t("global.tolist")
                    }}
                  </button>
                  <button
                    class="btn btn-primary mr-2"
                    @click="goToHelpPage"
                    v-tooltip
                    :title="$t('global.textcodeshelppage')"
                  >
                    <font-awesome-icon
                      icon="fa-solid fa-circle-info"
                      class="mr-2"
                    />
                    {{ $t("global.help") }}
                  </button>
                </div>
                <div class="mr-4">
                  <button
                    v-if="berechtigungen.m_korrespondenz.delete"
                    class="btn btn-danger"
                    @click="oeffneLoeschenModal"
                  >
                    <font-awesome-icon
                      class="mr-1"
                      icon="fa-duotone fa-trash"
                    />
                    <span>{{ $t("global.delete") }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <korrespondenz-vorlage-stammdaten
          :navbarTitel="navbarTitel"
          :korrespondenz="korrespondenz"
          :langs="langs"
          @translate="translate"
          :editable="editable"
        />
        <!--  <div v-for="(inhalt, index) in 4" :key="index">
          <korrespondenz-vorlage-inhalt
            :navbarTitel="navbarTitel"
            :korrespondenz="korrespondenz"
            @unterschrift1updated="unterschrift1Updated"
            @unterschrift2updated="unterschrift2Updated"
          />
        </div> -->
        <div class="col-xl-12 p-0 d-flex">
          <div
            v-for="(lang, index) in langs"
            :key="'headline-' + index"
            class="col-2 p-0 mr-1"
          >
            <div class="col clickable p-0" @click="setActiveLang(index)">
              <div
                class="block block-kopf bg-medium-blue"
                :class="activeLang === index ? '' : 'bg-grayscale-5 hover'"
              >
                <span class="col primary-headline-text p-0">
                  {{ $t("global.content") + " " + lang.kuerzel }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-12 row d-flex">
          <div
            v-for="(lang, index) in langs"
            :key="'content-' + index"
            class="col-12 p-0"
          >
            <korrespondenz-vorlage-inhalt
              v-if="activeLang === index"
              :lang="lang"
              :navbarTitel="navbarTitel"
              :korrespondenz="korrespondenz"
              @unterschrift1updated="unterschrift1Updated"
              @unterschrift2updated="unterschrift2Updated"
              :editable="editable"
            />
          </div>
        </div>
      </div>
    </ValidationObserver>

    <loeschen-modal
      id="korrespondenz-vorlage-loeschen-modal"
      @confirmed="korrespondenzLoeschen"
    />

    <loading-overlay v-show="loading"></loading-overlay>
  </div>
</template>

<script>
//import Api from "@/Api";
import CommunicationApi from "@/api/CommunicationApi";
import store from "@/store";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import { LADE_AUSWAHLWERTE_EINSTELLUNGEN } from "@/store/einstellungendashboard/actions.type";

import page from "@/mixins/Page";

import ClassicEditor from "/custom/custom_ckeditor/build/ckeditor";
import HeadMenu from "@/components/HeadMenu";
import Navbar from "@/components/Navbar";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import KorrespondenzVorlageInhalt from "@/components/Kommunikation/KorrespondenzVorlageInhalt.vue";
import KorrespondenzVorlageStammdaten from "@/components/Kommunikation/KorrespondenzVorlageStammdaten.vue";

export default {
  name: "KorrespondenzTemplate",
  components: {
    HeadMenu,
    Navbar,
    LoeschenModal,
    KorrespondenzVorlageInhalt,
    KorrespondenzVorlageStammdaten,
  },
  mixins: [page],
  store,
  props: {
    id: {
      type: String,
      default: null,
    },
    anzeige: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      activeLang: 0,
      korrespondenz: {
        korrespondenzkategorie: null,
        unterschrift1: { person: this.$t("global.notlinked") },
        unterschrift2: { person: this.$t("global.notlinked") },
        /*  unterschrift1: { person: { personName: this.$t("global.notlinked") } },
        unterschrift2: { person: { personName: this.$t("global.notlinked") } }, */
        translation: {
          de: { betreff: "", text: "" },
          en: { betreff: "", text: "" },
          fr: { betreff: "", text: "" },
          it: { betreff: "", text: "" },
        },
      },
      editable: true,
      loading: false,

      editor: ClassicEditor,
      //inhalt: "<p>Content of the editor.</p>",
      /* langs: [
        {
          id: "1751CDBCE1E",
          kuerzel: "DE",
          bezeichnung: "Deutsch",
          deeplKuerzel: "de",
        },
        {
          id: "180BC941F1F",
          kuerzel: "EN",
          bezeichnung: "Englisch",
          deeplKuerzel: "en-us",
        },
        {
          id: "186559F7DBF",
          kuerzel: "FR",
          bezeichnung: "Franzoesisch",
          deeplKuerzel: "fr",
        },
        {
          id: "187B79C94AC",
          kuerzel: "IT",
          bezeichnung: "Italienisch",
          deeplKuerzel: "it",
        },
      ], */
    };
  },
  computed: {
    langs: {
      get() {
        return this.$store.state.einstellungendashboard.sprachen;
      },
    },
    navbarTitel: function () {
      if (this.id) {
        return this.$t("global.correspondencetemplate");
      } else {
        return this.$t("global.newcorrespondencetemplate");
      }
    },
    inhaltVorhanden() {
      let defaultSprache = this.langs.find((lang) => {
        return lang.id === this.korrespondenz.defaultsprache;
      });
      if (
        this.korrespondenz.translation[defaultSprache.kuerzel].text &&
        this.korrespondenz.translation[defaultSprache.kuerzel].betreff
      ) {
        return true;
      } else return false;
    },
  },

  watch: {
    id: {
      handler: function (val) {
        if (val) {
          this.ladeKorrespondenz(val);
        }
      },
      immediate: true,
    },
  },

  created() {},

  mounted: function () {
    if (this.langs.length == 0) {
      this.$store.dispatch(
        `einstellungendashboard/${LADE_AUSWAHLWERTE_EINSTELLUNGEN}`
      );
    }
  },

  methods: {
    unterschrift1Updated(u1) {
      if (u1) {
        if (!u1.id) return;

        this.korrespondenz.unterschrift1.person = u1.person.personName;
        this.korrespondenz.unterschrift1.id = u1.id;
      } else {
        this.korrespondenz.unterschrift1 = {};
      }
    },
    unterschrift2Updated(u2) {
      if (u2) {
        if (!u2.id) return;

        this.korrespondenz.unterschrift2.person = u2.person.personName;
        this.korrespondenz.unterschrift2.id = u2.id;
      } else {
        this.korrespondenz.unterschrift2 = {};
      }
    },
    ladeKorrespondenz(id) {
      this.loading = true;
      CommunicationApi.get("correspondence-template/" + id, {
        // params: { id: id },
      })
        .then((response) => {
          this.initializeKorrespondenz(response.data);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    speichern() {
      if (this.loading) return;

      if (this.inhaltVorhanden) {
        this.loading = true;
        var json = Object.assign({}, this.korrespondenz);

        if (json.translation) {
          for (const [key, value] of Object.entries(json.translation)) {
            this.$set(value, "text", this.unhighlightTextcodes(value.text));
          }
        }

        if (!this.id) {
          CommunicationApi.post("correspondence-template/", json)
            .then((response) => {
              this.initializeKorrespondenz(response.data);
              this.$notify({
                type: "success",
                title: this.$t("global.actionsuccessful"),
                text: this.$t("global.correspondencetemplatesavedsuccessfully"),
              });

              this.$router.replace({
                name: "korrespondenz-vorlage",
                params: { id: response.data.id, anzeige: 0 },
              });
            })
            .catch((e) => {
              this.$notify(apiErrorToAlert(e));
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          CommunicationApi.put("correspondence-template/" + this.korrespondenz.id, json)
            .then((response) => {
              this.initializeKorrespondenz(response.data);
              this.$notify({
                type: "success",
                title: this.$t("global.actionsuccessful"),
                text: this.$t("global.correspondencetemplatesavedsuccessfully"),
              });
            })
            .catch((e) => {
              this.$notify(apiErrorToAlert(e));
            })
            .finally(() => {
              this.loading = false;
            });
        }
      } else {
        this.$notify({
          type: "error",
          title: this.$t("global.actionfailed"),
          text: this.$t(
            "global.pleasefillincontentandsubjectforatleastonelanguage"
          ),
        });
      }
    },

    abbrechen() {
      this.$router.push({ name: "korrespondenz-vorlagen-liste" });
    },

    initializeKorrespondenz(korrespondenz) {
      if (korrespondenz) {
        this.korrespondenz = korrespondenz;

        if (!korrespondenz.unterschrift1) {
          this.korrespondenz.unterschrift1 = {
            person: this.$t("global.notlinked"),
          };
        }

        if (!korrespondenz.unterschrift2) {
          this.korrespondenz.unterschrift2 = {
            person: this.$t("global.notlinked"),
          };
        }

        if (this.korrespondenz.translation) {
          for (const [key, value] of Object.entries(
            this.korrespondenz.translation
          )) {
            this.$set(value, "text", this.highlightTextcodes(value.text));
          }
        }
      } else {
        console.error("korrespondenz ist null");
      }
      this.editable = !this.berechtigungen.m_korrespondenz.update
        ? false
        : this.editable;
    },

    korrespondenzLoeschen() {
      // let selectedIds = [this.id];
      CommunicationApi.delete("correspondence-template/" + this.id).then(() => {
        this.$router.replace({ name: "korrespondenz-vorlagen-liste" });
      });
    },

    oeffneLoeschenModal() {
      this.$bus.$emit(
        "openLoeschenModal",
        "korrespondenz-vorlage-loeschen-modal"
      );
    },
    translate(sourceLang, targetLangs) {
      this.loading = true;
      let payload = {
        sourceLanguage: sourceLang.kuerzel,
        targetLanguageList: targetLangs,
      };

      let sourceText = this.unhighlightTextcodes(
        this.korrespondenz.translation[sourceLang.kuerzel].text
      );

      payload.sourceTextList = [];
      payload.sourceTextList[0] = sourceText;
      payload.sourceTextList[1] =
        this.korrespondenz.translation[sourceLang.kuerzel].betreff;

      const json = Object.assign({}, payload);
      CommunicationApi.post("correspondence-template-deepl/", json)
        .then((response) => {
          let thislangs = this.langs.filter((lang) => {
            return targetLangs.includes(lang.kuerzel);
          });
          thislangs.forEach((lang) => {
            if (lang.kuerzel !== sourceLang.kuerzel) {
              this.setText(response.data[0].translation_list, lang);
              this.setSubject(response.data[1].translation_list, lang);
            }
          });
          this.$notify({
            type: "success",
            title: this.$t("global.actionsuccessful"),
            text: this.$t("global.translationwassuccessful"),
          });
        })
        .catch(() => {
          this.$notify({
            type: "error",
            title: this.$t("global.actionfailed"),
            text: this.$t("global.translationwasunsuccessful"),
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setActiveLang(index) {
      this.activeLang = index;
    },
    setText(translationList, lang) {
      this.korrespondenz.translation[lang.kuerzel].text = translationList.find(
        (translation) => translation.translation_language == lang.kuerzel
      ).translation;

      this.korrespondenz.translation[lang.kuerzel].text =
        this.highlightTextcodes(
          this.korrespondenz.translation[lang.kuerzel].text
        );
    },
    setSubject(translationList, lang) {
      this.korrespondenz.translation[lang.kuerzel].betreff =
        translationList.find(
          (translation) => translation.translation_language == lang.kuerzel
        ).translation;
    },
    highlightTextcodes(text) {
      if (!text) return "";

      const pattern = /(@\[([^\]]+)\])|(\{([^}]+)\})/g;

      return text.replace(pattern, (match, p1, p2, p3, p4) => {
        const highlightedText = p1 || p3;
        return highlightedText
          ? `<span style="color:#5299e0;">${highlightedText}</span>`
          : match;
      });
    },
    unhighlightTextcodes(text) {
      if (!text) return "";

      const pattern =
        /<span style="color:#5299e0;">([^<]+)<\/span>|<span style="color:#8bc34a;">([^<]+)<\/span>/g;

      return text.replace(pattern, (match, p1, p2) => {
        if (p1) return p1;
        if (p2) return p2;
      });
    },
    goToHelpPage() {
      window.open(
        this.$CONST("CONFIG").BASEURL +
          "/help/massenkorrespondenz/brief-feldfunktionen/",
        "_blank"
      );
    },
  },
};
</script>

<style></style>
